
import React from 'react'
import PropTypes from 'prop-types'
import { ToastContainer, ToastMessage } from 'react-toastr'
import { verifyAuth, getToken } from '../Commons/Authentication'
import { hashHistory } from 'react-router'
// redux
import { connect } from 'react-redux'
import * as actionsRedux from '../../redux/actions/percentil'

import NavigationBar from '../Commons/NavigationBar'
import Slider from './Component/Slider'
import CharCoordinates from './Component/CharCoordinates'
import PieChar from './Component/PieChar'
import { Link } from 'react-router'
import './afecto.css'

// import {afecto} from './Component/calculo'
Slider.defaultProps = {
  disabled: false,
  max: 0.1,
  min: 0,
  step: 0.01,
  value: 0.01
}
const ToastMessageFactory = React.createFactory(ToastMessage.animation)
class Percentil extends React.Component {

  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.save = this.save.bind(this)
    this.afectoPercentil = {
      preocupacion: 0,
      contento: 0,
      tranquilo: 0,
      desanimo: 0,
      optimista: 0,
      satisfecho: 0,
      irritable: 0,
      decepcionado: 0,
      bienestar: 100,
      malestar: 0
    }
    this.saving = false; 
  }
  componentDidMount () {
    this.load()
  }
  save () {
    let array = this.props.Percentil
    array.paciente = this.props.params.id
    array.health = this.props.params.health
    let headers = {'Content-Type': 'application/json'}
    headers['Authorization'] = `Bearer ${getToken()}`
    if (this.saving === false) {
      this.saving = true
      this.refs.container.warning('Espera mientras se salva la información:', '', { closeButton: true })
      fetch('api/v1/affection', { method: 'POST', headers, body: JSON.stringify(array) })
      .then((res) => {
        return res.json()
      }).then((res) => {
        let {_id} = res
        this.setState({_id})
        this.refs.container.success('Se a guardado:', '', { closeButton: true })
        setTimeout(() => {
          hashHistory.push('estadoSaludDashboard/' + this.props.params.patient)
        }, 1800)
      })
    } else {
      array._id = this.state._id
      fetch('api/v1/affection', { method: 'PUT', headers, body: JSON.stringify(array) })
      .then((res) => {
        return res.json()
      }).then((res) => {
        this.refs.container.success('Registro Actualizado:', '', { closeButton: true })
        setTimeout(() => {
          hashHistory.push('estadoSaludDashboard/' + this.props.params.patient)
        }, 1800)
      })
    }
  }
  classSelector (target) {
    if (target > 0) {
      return 'green'
    }
    else {
      return 'transparent'
    }
  }
  classSlider (target, className) {
    if (target > 0) {
      return ` ${className}`
    }
    else {
      return `cero ${className}`
    }
  }
  load () {
    let health = this.props.params.health
    let headers = {'Content-Type': 'application/json'}
    headers['Authorization'] = `Bearer ${getToken()}`
    fetch(`api/v1/affection/?health=${health}&sort=-1&limit=1`, { method: 'Get', headers })
    .then((res) => {
      return res.json()
    }).then((res) => {
      console.log(res)
      if (res[0]) {
        if (res[0]._id) {
          this.afectoPercentil = {...this.afectoPercentil, ...res[0]}
          this.props.setCalcAfecto(this.afectoPercentil)
          this.saving = true
          this.setState({_id: res[0]._id})
        } 
      } else {
        this.props.setCalcAfecto(this.afectoPercentil)
      }
    })
  }
  handleChange (e, obj) {
    this.afectoPercentil = {...this.afectoPercentil, ...obj}
    this.props.setCalcAfecto(this.afectoPercentil)
  }
  render () {
    document.title = 'Afectividad'
    let {
      preocupacion,
      contento,
      tranquilo,
      desanimo,
      optimista,
      satisfecho,
      irritable,
      decepcionado
    } = this.props.Percentil
    let width = 360
    let widthPie = 300
    try{
      width= document.getElementById('char').offsetWidth
      widthPie= document.getElementById('pie').offsetWidth
    } catch(e) {}
    let url = `estadoSaludDashboard/${this.props.params.patient}`
    return (
      <div id="afecto">
        <NavigationBar></NavigationBar>
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="container"
          className="toast-top-right"
        />
        <h2 className='titleA'>Evaluación del afecto</h2>
        <div className='decriptionAf'> <span>EL AFECTO es una sensación interior subjetiva perdurable (Agradable ó Desagradable), </span> <br></br> <span>de cierta intensidad, que podemos percibir y tiene representación neurofisiológica.</span></div>
        <div className='container-afe'>
          <div className='form-slider-container'>
            <div className='item'>
              <div className='slider-grid'>
                <label>Preocupación </label><div className={`${this.classSelector(preocupacion)}`}>✔</div>
              </div>
              <div className='slider-grid'>
                <Slider id="preocupacion" className={this.classSlider(preocupacion, 'bad')} value={preocupacion} onChange={this.handleChange} showProgress={true} min={0} max={10} step={1} />
                <div className='feedback-afe'><span>{preocupacion}</span></div>
              </div>
            </div>
            <div className='item'>
            <div className='slider-grid'>
              <label>Contento</label><div className={`${this.classSelector(contento)}`}>✔</div>
            </div>
              <div className='slider-grid'>
                <Slider id="contento" className={this.classSlider(contento, ' ')}  value={contento} onChange={this.handleChange} showProgress={true} min={0} max={10} step={1} />
                <div className='feedback-afe'><span>{contento}</span></div>
              </div>
            </div>
            <div className='item'>
              <div className='slider-grid'>
                <label>Tranquilidad</label><div className={`${this.classSelector(tranquilo)}`}>✔</div>
              </div>
              <div className='slider-grid'>
                <Slider id="tranquilo" className={this.classSlider(tranquilo, ' ')}  value={tranquilo} onChange={this.handleChange} showProgress={true} min={0} max={10} step={1} />
                <div className='feedback-afe'><span>{tranquilo}</span></div>
              </div>
            </div>
            <div className='item'>
              <div className='slider-grid'>
                <label>Satisfacción </label><div className={`${this.classSelector(satisfecho)}`}>✔</div>
              </div>
              <div className='slider-grid'>
                <Slider id="satisfecho" className={this.classSlider(satisfecho, ' ')} value={satisfecho} onChange={this.handleChange} showProgress={true} min={0} max={10} step={1} />
                <div className='feedback-afe'><span>{satisfecho}</span></div>
              </div>
            </div>
            <div className='item'>
              <div className='slider-grid'>
                <label>Optimismo</label><div className={`${this.classSelector(optimista)}`}>✔</div>
              </div>
              <div className='slider-grid'>
                <Slider id="optimista" className={this.classSlider(optimista, ' ')} value={optimista} onChange={this.handleChange} showProgress={true} min={0} max={10} step={1} />
                <div className='feedback-afe'><span>{optimista}</span></div>
              </div>
            </div>
            <div className='item'>
              <div className='slider-grid'>
                <label>Desanimo</label><div className={`${this.classSelector(desanimo)}`}>✔</div>
              </div>
              <div className='slider-grid'>
                <Slider id="desanimo" className={this.classSlider(desanimo, 'bad')} value={desanimo} onChange={this.handleChange} showProgress={true} min={0} max={10} step={1} />
                <div className='feedback-afe'><span>{desanimo}</span></div>
              </div>
            </div>
            <div className='item'>
              <div className='slider-grid'>
                <label>Irritabilidad</label><div className={`${this.classSelector(irritable)}`}>✔</div>
              </div>
              <div className='slider-grid'>
                <Slider id="irritable" className={this.classSlider(irritable, 'bad')} value={irritable} onChange={this.handleChange} showProgress={true} min={0} max={10} step={1} />
                <div className='feedback-afe'><span>{irritable}</span></div>
              </div>
            </div>
            <div className='item'>
            <div className='slider-grid'>
              <label>Decepcion</label><div className={`${this.classSelector(decepcionado)}`}>✔</div>
            </div>
              <div className='slider-grid'>
                <Slider id="decepcionado" className={this.classSlider(decepcionado, 'bad')} value={decepcionado} onChange={this.handleChange} showProgress={true} min={0} max={10} step={1} />
                <div className='feedback-afe'><span>{decepcionado}</span></div>
              </div>
            </div>
          </div>
          <div id='char' className="victory-char">
            <CharCoordinates width={width} height={width} vector={this.props.Percentil}></CharCoordinates>
            <div className='descriptionText'>
            <h2>Análisis vectorial del afecto </h2>
            este análisis permite visualizar en un plano bidimensional la dirección e intensidad de la expresión del afecto. Se resume en 4 cuadrantes: con alta intensidad en la mitad superior y si es agradable (mitad derecha) o desagradable (mitad izquierda). Cuando el afecto se sitúa a la izquierda (afecto negativo), usualmente se requiere apoyo para mejorarlo y si esta en el cuadrante inferior izquierdo se necesita intervención terapéutica especifica.

            </div>
          </div>
          <div id='pie' className="victory-char">
            <PieChar width={widthPie} height={widthPie} vector={this.props.Percentil}></PieChar>
            <div className='descriptionText'>
           <h2>Nivel de bienestar </h2>
            Se obtiene sumando todos los 8 factores que genera el vector del afecto y permite calcular el porcentaje de bienestar. Valor normal >=70%. Un alto bienestar con un vector en la mitad derecha de la gráfica (afecto positivo) se considera normal

            </div>
          </div>
      </div>
      <div className='container-button-afecto'>
            <div></div>
            <div className='btn'>
              <Link to={url}> Dashboard </Link>
            </div>

            <div className='btn' onClick={this.save}>Guardar</div>
            <div></div>
      </div>
      </div>

    )
  }
}
Percentil.propTypes = {
  Percentil: PropTypes.object,
  preocupacion: PropTypes.number,
  contento: PropTypes.number,
  tranquilo: PropTypes.number,
  desanimo: PropTypes.number,
  optimista: PropTypes.number,
  satisfecho: PropTypes.number,
  irritable: PropTypes.number,
  decepcionado: PropTypes.number,
  setCalcAfecto: PropTypes.func,
  id: PropTypes.string,
  params: PropTypes.object
}

// Reducer
const mapStateToProps = state => {
  return { Percentil: state.Percentil }
}

export default connect(mapStateToProps, actionsRedux)(Percentil)




// WEBPACK FOOTER //
// ./src/components/Patient/Percentil.js